import { CONTAINER } from './LayoutTypes';

/**
* Finds the root layout item of the given layout item..
*/
export default function getRootLayoutItem(widgetsState, item) {
  const parent = widgetsState[item.layout.parentId];
  if (parent.layout.type === CONTAINER) {
    return parent;
  }
  return getRootLayoutItem(widgetsState, parent);
}
